import setAppPaneUnderlayVisibility from 'owa-app-pane-underlay/lib/actions/setAppPaneUnderlayVisibility';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';
import { drawerPaneClosed } from '../actions/drawerPaneClosed';
import { drawerPaneShownChanged } from '../actions/drawerPaneShownChanged';
import getActiveDrawerPane from '../selectors/getActiveDrawerPane';
import getTabIdFromWindow from '../utils/getTabIdFromWindow';
import getUnderlay from '../utils/getUnderlay';

/**
 * Opens the drawer pane for the given target window.
 * @param paneId - The ID of the pane to open.
 * @param targetWindow - The target window where the pane should be opened.
 * @param showAppUnderlay - Optional parameter to show the app pane as an underlay pane, which will move the app content to the side.
 */
export default function openDrawerPane(
    paneId: string,
    targetWindow: Window = window,
    showAppUnderlay: boolean = true
): void {
    const tabId = getTabIdFromWindow(targetWindow);
    const activePane = getActiveDrawerPane(tabId);

    // If the pane is already open, we don't need to do anything.
    if (activePane === paneId) {
        return;
    }

    // Set the pane as shown (also closes any previously shown pane for this window).
    drawerPaneShownChanged(paneId, true, targetWindow);

    // Show the underlay for the drawer pane.
    // The underlay is used to move the content of the app to the side when the pane is open.
    if (showAppUnderlay) {
        setAppPaneUnderlayVisibility(
            'drawerPane',
            true /* isShown */,
            isPopout(targetWindow) ? false : true /* shrinkable */,
            undefined /* isPlaceholder */,
            getUnderlay(targetWindow) /* underlay */
        );
    }

    // Notify that the previous pane has been closed.
    if (activePane && activePane !== paneId) {
        drawerPaneClosed(activePane, targetWindow);
    }
}
